import { useRef, useEffect } from "react";
import { useEvent as o } from "./use-event.js";
function m(u, t) {
  let e = useRef([]), r = o(u);
  useEffect(() => {
    let o2 = [...e.current];
    for (let [a, l] of t.entries()) if (e.current[a] !== l) {
      let n = r(t, o2);
      return e.current = t, n;
    }
  }, [r, ...t]);
}
export {
  m as useWatch
};
